export default __webpack_public_path__ + "static/media/waves.b353a481.png";